module.exports = __webpack_public_path__ + "static/home-working-process-img-1fa7b7891aacb0eb44ea5a367ea8274d.png";